import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const SynonymEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    synonym: z.string(),
    languageCode: z.string().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
